import { configureStore } from '@reduxjs/toolkit';
import thunk from "redux-thunk";
import reducer from "./reducers";
const middleware = [thunk];
export default configureStore({
  middleware: middleware,
  reducer: {reducer},
})